/* 
  Welcome to the custom js section 
  This code does not belong to the theme.
  This code is written by Yours Truly. 
*/

// // Helper Functions
function removeDollarSign(str) {
    return parseFloat(str.replace(/[^0-9.]/g, ""));
}

function addDollarSign(num) {
    return `$${num}`;
}

document.addEventListener('DOMContentLoaded', function () {
    
    const makeThePaymentBlack = (paymentTermsText) => {
        if (paymentTermsText?.shadowRoot) {
            const elements = [
                paymentTermsText.shadowRoot.querySelector('#shopify-installments'),
                paymentTermsText.shadowRoot.querySelector('#shopify-installments .align-middle')
            ];
            elements.forEach(el => el && (el.style.color = 'black'));
        }
    };

    const updateLocalStorage = () => {
        const productPrice = document.querySelectorAll(".shappify_qb_grid tbody tr td:last-child");
        const priceItem = document.querySelector(".price-item");
        if (productPrice.length > 0) {
            const basePrices = Array.from(productPrice).map(price => removeDollarSign(price.textContent));
            const basePriceItem = priceItem ? removeDollarSign(priceItem.textContent) : null;
            localStorage.setItem("basePrices", JSON.stringify(basePrices));
            localStorage.setItem("basePriceItem", basePriceItem);
        }
    };

    const updatePrices = () => {
        const productPrice = document.querySelectorAll(".shappify_qb_grid tbody tr td:last-child");
        const priceItem = document.querySelector(".price-item");
        const basePrices = JSON.parse(localStorage.getItem("basePrices")) || [];
        const basePriceItem = parseFloat(localStorage.getItem("basePriceItem")) || 0;
    
        const checkedRadio = document.querySelector(".cl-po--radio-item input[type='radio']:checked");
        
        // Do nothing if no decoration type is selected
        if (!checkedRadio || checkedRadio.value === undefined) {
            return;
        }
    
        const isSample = checkedRadio.value === "Sample";
    
        productPrice.forEach((price, index) => {
            price.textContent = addDollarSign(
                isSample ? basePrices[index].toFixed(2) : (basePrices[index] + 8).toFixed(2)
            );
        });
    
        if (priceItem) {
          // setTimeout(() => {
            priceItem.textContent = addDollarSign(isSample ? basePriceItem.toFixed(2) : (basePriceItem + 8).toFixed(2));
          // }, 100)
        }
    };


    const priceContainerObserver = new MutationObserver((mutations, obs) => {
        if (document.querySelector(".shappify_qb_grid tbody tr td:last-child")) {
            obs.disconnect();
            updateLocalStorage();
            updatePrices();
        }
    });

    priceContainerObserver.observe(document.body, {
        childList: true,
        subtree: true
    });

    const variantRadios = document.querySelector("variant-radios");
    if (variantRadios) {
        variantRadios.addEventListener("change", function () {
           // alert(`updating price.textContent`);
            setTimeout(() => {
                updateLocalStorage();
                updatePrices();
            }, 1000);
        });
    }

  window.addEventListener('load', function () {
    const decorationTypes = document.querySelector(".cl-po--option");
    if (decorationTypes) {
        decorationTypes.addEventListener("change", function () {
          var event = new Event('change');
          
          // Dispatch it.
            setTimeout(() => {
                updatePrices();
                // variantRadios.dispatchEvent(event);
            }, 1000);
        });
    }
  })

    const quantityObserver = new MutationObserver(() => {
        makeThePaymentBlack(document.querySelector('shopify-payment-terms'));
    });
    
    if (document.querySelector(".product-form__quantity")) {
        quantityObserver.observe(document.querySelector(".product-form__quantity"), {
            attributes: true,
            childList: true,
            subtree: true
        });
    }
});

